import { ALL_DIAL_CODES } from "../../constants/phoneDialCodes";

/**
 * Split a stored phone value into ITU-T dial code + national subscriber number.
 * When `raw` is E.164 (leading +), the longest matching dial prefix from {@link ALL_DIAL_CODES}
 * wins so values like +9181… are not mis-parsed with a stale fallback dial (e.g. +34).
 */
export function splitDialNationalFromStored(raw: string, fallbackDial: string): { national: string; dial: string } {
  const s = String(raw ?? "").trim();
  const fb = (fallbackDial || "").trim() || "+34";
  if (!s) return { national: "", dial: fb };
  if (!s.startsWith("+")) return { national: s, dial: fb };
  const sorted = [...ALL_DIAL_CODES].sort((a, b) => b.code.length - a.code.length);
  for (const { code } of sorted) {
    if (s.startsWith(code)) {
      return { dial: code, national: s.slice(code.length).trim() };
    }
  }
  return { national: s.replace(/^\+\d+/, "").trim() || s, dial: fb };
}
